/**
 * 点了推荐位上的一道菜之后，要不要先弹出"选规格 / 选配菜"那一层。
 * Whether tapping a recommended dish must open the customise sheet first.
 *
 * 这里只回答"这道菜有没有需要顾客决定的东西"，**不看当前勾选状态**。
 *
 * 历史坑（本文件存在的原因）：原来的判据是"找一个一样都没勾的配菜组"。
 * 在"没有任何预勾选"的年代它恰好等价于"有没有配菜组"，
 * 但商家可以配"默认勾选"之后就不再等价了 —— 每个组都被预勾满的推荐菜
 * 会被判成"不用选"，顾客点一下卡片就直接加进购物车，
 * 配菜连同它的加价一起静默计入实付金额，而卡片上写的还是不含配菜的价格。
 *
 * The old test was "find a section with nothing ticked", which silently
 * became "no customisation needed" once options could start pre-ticked —
 * the dish went straight into the cart and its extras were charged without
 * ever being shown. Ask about the menu shape, never about the tick state.
 */

/**
 * 这道菜有没有配菜组。
 * @param {Object} product 商品 / product
 * @returns {Boolean}
 */
export const hasModifierGroups = (product) =>
  Array.isArray(product?.modifications) && product.modifications.length > 0

/**
 * 这道推荐菜要不要先让顾客选一下（规格或配菜）。
 * 套餐要不要单独判由调用方决定 —— 主商品页会额外判 `type === 'combo'`，
 * 弹层里的推荐位历来不判，两边刻意保持各自的现状。
 *
 * @param {Object} product 推荐菜 / the recommended product
 * @returns {Boolean}
 */
export const recommendNeedsCustomise = (product) => {
  if (!product) return false
  if (product.selectSize?.name) return true
  if (product.sizeSettings?.mutipleSize) return true
  return hasModifierGroups(product)
}
